import ArticleList from './article-list';

export default ArticleList;
